module.exports = __webpack_public_path__ + "lodash.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[name].[ext]!./~/lodash/lodash.js?
// module id = 85
// module chunks = 2